const SURROGATE_HIGH_START = 0xd800;
const SURROGATE_HIGH_END = 0xdbff;
const SURROGATE_LOW_START = 0xdc00;
const SURROGATE_LOW_END = 0xdfff;

// Determines if a pair of characters are in the range  to form a pair, for example to represent an
// emoji, they don't neccessarily have to represent an actual known emoji.
// Adapted from https://github.com/facebook/fbjs/blob/5300adaec134f532391dfac65d574cc066fe593e/packages/fbjs/src/unicode/UnicodeUtils.js
export const isSurrogatePair = (first: string, second: string) => {
  const firstCode = first.charCodeAt(0);
  const secondCode = second.charCodeAt(0);
  return (
    SURROGATE_HIGH_START <= firstCode &&
    firstCode <= SURROGATE_HIGH_END &&
    SURROGATE_LOW_START <= secondCode &&
    secondCode <= SURROGATE_LOW_END
  );
};
